module.exports = __webpack_public_path__ + "static/media/nature_image_presentation.f0a20f75.png";